$(function(){
  $(document).on("click", ".rb-list-tab-select", function(){
    var selectedSchoolType = $(this).data('school-type')
    if (selectedSchoolType === '') {
      const ids_ele = $('#rb-school-input-ids')
      const name_ele = $('#rb-school-input-name')
      if (ids_ele.length !== 0) {
        // 希望条件作成用
        let input = document.createElement('input')
        input.setAttribute('value', $(this).data('id'))
        input.setAttribute('multiple', 'multiple')
        input.setAttribute('autocomplete', 'off')
        input.setAttribute('type', 'hidden')
        input.setAttribute('name', 'registration_wish[block_school_ids][]')
        input.setAttribute('id', 'registration_wish_block_school_ids')

        ids_ele.append(input)

        var names = name_ele.text() ? [name_ele.text()].map((item) => { return item }) : []
        names.push($(this).data('name'))
        name_ele.text(names.join(','))
        $('.modal-definitive').fadeOut()
      } else {
        // マイページ>ブロック学校用
        $('#block_school_id').val($(this).data('id'))
        name_ele.html($(this).data('name'))
        $('.modal-definitive').fadeOut()
      }
    } else {
      var isDirectInput = $(this).data('direct-input') === true
      var $univIdInput, $nameInput

      if($("#rb-school-select-active").length) {
        $univIdInput = $("#rb-school-select-active").find(".rb-school-select-univid")
        $nameInput = $("#rb-school-select-active").find(".rb-school-select-name")
      } else {
        $univIdInput = $('#rb-school-input-' + selectedSchoolType + '-id')
        $nameInput = $('#rb-school-input-' + selectedSchoolType + '-name')
      }

      if (isDirectInput) {
        $univIdInput.val('')
        $nameInput.val('').prop('readonly', false).removeClass('is-readonly')
          .attr('placeholder', '学校名を直接入力してください')
          .attr('data-parsley-required-message', '学校名を直接入力してください')
        $('.modal-definitive').fadeOut()
        setTimeout(function() { $nameInput.focus() }, 300)
      } else {
        $univIdInput.val($(this).data('id'))
        $nameInput.val($(this).data('name')).prop('readonly', true).addClass('is-readonly')
          .attr('placeholder', '学校選択ボタンから選択してください')
          .attr('data-parsley-required-message', '学校選択ボタンから選択してください')
        $('.modal-definitive').fadeOut()
      }
    }
  })

  $(document).on("click", ".rb-search-school-word", function(){
    var val = $(this).prev().val()
    var searchUrl = $(this).data('search-url') || '/registrations/school_searches'
    $.ajax({
      url: searchUrl,
      type: 'GET',
      dataType: 'script',
      data: {
        search_type: 'word',
        tabindex: 0,
        school_type:  $(this).data('school-type'),
        word: val
      }
    })
  })

  // Handle ENTER key in school search text input to trigger search instead of form submission
  $(document).on("keydown", ".search-filter .c-input[type='text']", function(e){
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault()
      e.stopPropagation()
      $(this).next('.rb-search-school-word').click()
    }
  })


  $(document).on("click", ".rb-graduate-chart-select", function(e){
    e.preventDefault();
    var schoolType = $(this).data('school-type')
    $('#rb-school-graduate-' + schoolType + '-year').val($(this).data('year'))
    $('#rb-school-graduate-' + schoolType + '-month').val(3)
    $('.modal-definitive').fadeOut()
  })

  // for school_input2
  // 学校選択


  $(document).on("click", ".rb-school-select", function(){
    $("#rb-school-select-active").removeAttr("id")
    $(this).parent().attr('id', 'rb-school-select-active');
    $(this).next().fadeIn();
  })

  $(document).on("click", ".rb-search-school-tab", function(){
    $(".rb-search-school-tab.-tabActive").removeClass('-tabActive')
    $(".rb-search-school-tab-contents.-tabShow").removeClass('-tabShow')

    $(this).addClass('-tabActive')
    var index = $('.rb-search-school-tab').index(this)
    $('.rb-search-school-tab-contents').eq(index).addClass('-tabShow')
  })

  $(document).on("click", ".rb-list-tab", function(e){
    e.preventDefault()
    var url = $(this).attr('href')
    $.ajax({
      url: url,
      type: 'GET',
      dataType: 'script'
    })
    // Scope selectors to the current modal to prevent affecting other modals
    var $modal = $(this).closest('.modal-definitive');
    var $listTabs = $modal.find('.list-tab');
    var $tabContents = $modal.find('.listtab-contents');
    
    $listTabs.removeClass('-listActive');
    $tabContents.removeClass('-tabShow');

    $(this).addClass('-listActive');

    var index = $listTabs.index(this);
    $tabContents.eq(index).addClass('-tabShow');

  })



  // 卒業早見表
  $(document).on("click", ".rb-graduate-chart", function(){
    $('#rb-graduate-chart-active').removeAttr('id')
    const parent = $(this).parent().parent();
    parent.attr('id', 'rb-graduate-chart-active')
    var modal = $(this).parent().parent().next().next()
    modal.fadeIn()
  })

  $(document).on("click", ".rb-graduate-chart-select-2", function(e){
    e.preventDefault();

    var schoolType = $(this).data('school-type');
    var modal = $(this).closest('.modal-definitive');
    var graduationSection = modal.prevAll('.field-select__date').first();
    
    if (graduationSection.length > 0) {
      graduationSection.find('.rb-school-graduate-year').val($(this).data('year'));
      graduationSection.find('.rb-school-graduate-month').val(3);
    }
    
    $('.modal-definitive').fadeOut()
  })

  // 卒業早見表のモーダルを閉じる
  $(document).on("click", ".modal-close", function(e){
    e.preventDefault();
    e.stopPropagation();
    $(this).closest('.modal-definitive').fadeOut()
  })

  // モーダル背景クリックで閉じる
  $(document).on("click", ".modal-bg", function(e){
    e.preventDefault();
    e.stopPropagation();
    $(this).closest('.modal-definitive').fadeOut()
  })


  $(document).on('click', ".rb-ib-license-modal-select-all", function(e){
    //e.preventDefault();
    var modalid = $(this).data('modal-id')
    var ckd = $(this).prop("checked")
    if (ckd) {
      $('.rb-ib-license-modal-' + modalid + '-checkbox').attr('checked', true).prop('checked', true).change();
    } else {
      $('.rb-ib-license-modal-' + modalid + '-checkbox').removeAttr('checked').prop('checked', false).change();
    }
  })
  $(document).on('click', ".rb-ib-license-modal-close", function(e){
    e.preventDefault();
    var modalid = $(this).data('modal-id')
    var out = ""
    $('.rb-ib-license-modal-' + modalid + '-checkbox:checked').each(function(){
      if (out) {
        out += ', '
      }
      out += $(this).data('name')
    })
    $('.rb-ib-license-modal-' + modalid + '-selected-data').text(out)
    $('.modal-definitive').fadeOut()
  })
})
